import useSWR from "swr";
import fetchDataService from "../services/fetchDataService";

export function useTraceableInstances(tokenData: any, params: any) {
  const { company_id, company, status, category_option_id, element_id, storehouse_id, group_id, search, page = 1, limit = 50 } = params || {};
  const companyKey = company_id || company;
  const url = "/traceability/get-instances";
  const swrKey = companyKey
    ? `${url}/${companyKey}/${status || "ALL"}/${category_option_id || "ALL"}/${element_id || "ALL"}/${group_id || "ALL"}/${search || ""}/${page}/${limit}`
    : null;

  const fetcher = () =>
    fetchDataService.post(url, tokenData.key, {
      ...params,
      company_id: companyKey,
      csrfToken: tokenData?.token?.uid,
    });

  const { data, error, isLoading, mutate } = useSWR(
    () => (tokenData?.key && companyKey ? [swrKey, tokenData?.token?.uid] : null),
    fetcher,
    { keepPreviousData: true }
  );

  return {
    instances: data?.instances || [],
    total: data?.total || 0,
    page: data?.page || page,
    limit: data?.limit || limit,
    error,
    isLoading,
    mutate,
  };
}

export function useTraceableInstance(tokenData: any, params: { instance_uid?: string; instance_id?: number; company_uid?: string }) {
  const { instance_uid, instance_id, company_uid } = params || {};
  const idKey = instance_uid || instance_id;
  const url = "/traceability/get-instance";
  const swrKey = idKey ? `${url}/${idKey}` : null;

  const fetcher = () =>
    fetchDataService.post(url, tokenData.key, {
      ...params,
      csrfToken: tokenData?.token?.uid,
    });

  const { data, error, isLoading, mutate } = useSWR(
    () => (tokenData?.key && idKey ? [swrKey, tokenData?.token?.uid] : null),
    fetcher
  );

  return {
    instance: data?.instance || null,
    error,
    isLoading,
    mutate,
  };
}

export function useTraceableGroups(tokenData: any, params: any) {
  const { company_id, company, status, category_option_id } = params || {};
  const companyKey = company_id || company;
  const url = "/traceability/get-groups";
  const swrKey = companyKey ? `${url}/${companyKey}/${status || "ALL"}/${category_option_id || "ALL"}` : null;

  const fetcher = () =>
    fetchDataService.post(url, tokenData.key, {
      ...params,
      company_id: companyKey,
      csrfToken: tokenData?.token?.uid,
    });

  const { data, error, isLoading, mutate } = useSWR(
    () => (tokenData?.key && companyKey ? [swrKey, tokenData?.token?.uid] : null),
    fetcher,
    { keepPreviousData: true }
  );

  return {
    groups: data?.groups || [],
    error,
    isLoading,
    mutate,
  };
}

export function useTraceableGroup(tokenData: any, params: { group_uid?: string; group_id?: number; company_uid?: string }) {
  const { group_uid, group_id, company_uid } = params || {};
  const idKey = group_uid || group_id;
  const url = "/traceability/get-group";
  const swrKey = idKey ? `${url}/${idKey}` : null;

  const fetcher = () =>
    fetchDataService.post(url, tokenData.key, {
      ...params,
      csrfToken: tokenData?.token?.uid,
    });

  const { data, error, isLoading, mutate } = useSWR(
    () => (tokenData?.key && idKey ? [swrKey, tokenData?.token?.uid] : null),
    fetcher
  );

  return {
    group: data?.group || null,
    error,
    isLoading,
    mutate,
  };
}
